import { type RouteObject } from 'react-router-dom';

import { requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const seasonPassRoute: RouteObject = {
  path: 'season-passes',
  loader: requirePermissions({ oneOf: PagePermissions.seasonPasses }),
  children: [
    {
      path: '',
      lazy: () => import('./seasonPasses'),
    },
  ],
};
